import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_RESPONSE__error extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.RESPONSE_ERROR;

  /*
   * FIELDS
   */
  type: string;
  info: any;

  /*
   * METHODS
   */

  constructor(type: string = '', info: object = {}) {
    super();

    this.type = type;

    (info as any)[CONSTANTS__shared.SERIALIZATION_CLASS_FIELD_INSTANCE] = ENUM__dto_class_name.OBJECT;

    this.info = info;
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.type);
  }
}
